module.exports = __webpack_public_path__ + "./fonts/Roboto-ThinItalic.ttf";